/*
 * @Author: cn1994
 * @Date: 2023-01-17 15:48:28
 * @LastEditors: cn1994
 * @LastEditTime: 2024-10-09 17:03:42
 * @Description: 登陆相关apis
 */
import request from '@/common/request.js'
import qs from 'qs'
import { useBaseStore } from "@/stores/base";
const baseStore = useBaseStore();

// 验证码登陆获取登陆验证码
export const getSMSCode = (data) => {
  const host = location.host.split(".")[0];
  let domain = 'http://s2.51tyty.com/center/services/rest'
  if (host.includes('pre')) {
    domain = 'http://pre.51tyty.com/center/services/rest'
  }
  return request({
    url: `BUSINESSDCP/user/SMS?phone=${data.phone}&smsType=login`,
    method: 'post',
    headers: {
      instid: null, // 发送验证码不要传instId
      token: null,
      serverId: null,
      devicetype: 5,
      apptype: 10,
      Deviceuniqueid: 'd91ed0b9-290c-4700-ad1e-1d619d625e54',
      domain: domain
    },
    data: { unused: 0 }, // 这一行是解决此请求带不上content-type的问题
  })
}

// 登录
export const accountLogin = (data) => {
  return request({
    url: `BUSINESS/login/index`,
    method: 'post',
    data
  })
}

// 获取登录二维码
export const getLoginQrcode = () => {
  // resource服务是一个独立的服务
  const host = location.host.split(".")[0];
  let domain = 'http://resource.51tyty.com/resource/services/rest'
  if (host.includes('pre')) {
    domain = 'http://pre.51tyty.com/resource/services/rest'
  }
  return request({
    url: `BUSINESSDCP/qrcode/Login/Qrcode`,
    method: 'put',
    headers: {
      instid: null,
      token: null,
      serverId: null,
      domain: domain,
    },
    data: { unused: 0 }, // 这一行是解决此请求带不上content-type的问题
  })
}

// 查询登录二维码状态
export const searchLoginQrcodeStatus = (params) => {
  return request({
    url: `BUSINESS/login/getQrcodeInfo`,
    method: 'get',
    params
  })
}
// 获取设置信息（实时数据、待办提醒、快捷功能）
export const getWorkbenchInfo = (params) => {
  return request({
    url: `OSS/index.php?g=workbench&m=index&a=getInfo`,
    method: 'get',
    params
  })
}
// 获取设置信息（实时数据、快捷功能）
export const getHomeData = (params) => {
  return request({
    url: `OSS/index.php?g=workbench&m=index&a=getHomeData`,
    method: 'get',
    params
  })
}
// 待办提醒
export const getHomeTodoData = (params) => {
  return request({
    url: `OSS/index.php?g=workbench&m=index&a=getHomeTodoData`,
    method: 'get',
    params
  })
}
// 修改设置信息（实时数据、待办提醒、快捷功能）
export const editHomeSetInfo = (data) => {
  return request({
    url: `OSS/index.php?g=workbench&m=index&a=update`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 新菜单引导确定
export const newMenuRead = (data) => {
  return request({
    url: `OSS/index.php?g=ApiV2&m=Mark&a=saveShow`,
    method: 'post',
    data: qs.stringify(data)
  })
}



export const uploadImg = baseStore.baseDomain + '/index.php?g=WebPageUrl&m=Upload&a=uploadImg'
export default {
  getSMSCode,
  accountLogin,
  getLoginQrcode,
  searchLoginQrcodeStatus,
  getWorkbenchInfo,
  getHomeData,
  getHomeTodoData,
  editHomeSetInfo,
  uploadImg,
  newMenuRead,
}
